
import { ModelOfAbastecimento } from 'src/modelreport/relabastecimento';
import api from '../../services/api';
import { useRef } from 'react';
import { Toast } from 'primereact/toast';

const PrintConsulmoCombustivel = () => {
    // const toastPrint: any = useRef();
    const toastPrintResumocombustivel = useRef<Toast>(null);

    const transformDataInBlob = (response: any, filename?: string) => {
        let blob = new Blob([response.data], {
            type: 'application/pdf',
        });

        if (response.data.byteLength < 100) {
            if (toastPrintResumocombustivel.current) {
                toastPrintResumocombustivel.current.show({
                    severity: 'warn',
                    summary: 'Falha na Operação.',
                    detail: 'Erro inesperado, tente novamente ou entre em contato',
                    life: 5000,
                });
            }

            return false;
        } else {
            if (toastPrintResumocombustivel.current) {
                toastPrintResumocombustivel.current.show({
                    severity: 'success',
                    summary: 'Autorização gerada com sucesso.',
                    detail: 'Verifique os seus downloads ou abas do navegador',
                    life: 5000,
                });
            }
        }

        const file = new File([blob], `${filename}-${new Date().toLocaleDateString()}.pdf`);

        let url = window.URL.createObjectURL(file);

        if (navigator.userAgent.match(/Chrome/i)) {
            url = window.URL.createObjectURL(blob);
        }

        let link = document.createElement('a');
        link.href = url;

        window.open(link.href);

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 100);
    };

    const sendToPrintResumoCombustivel = async (data: ModelOfAbastecimento[]) => {
        try {
            console.log("sendToPrintResumoCombustivel data: ",data)
            await api
                .post(`printResumoCombustivel`, data, {
                    responseType: 'arraybuffer',
                })
                .then(response => {
                    transformDataInBlob(response, 'PDF');
                });
        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    return {
        printCallResumoCombustivel: {
            sendToPrintResumoCombustivel,
            toastPrintResumocombustivel,
        },
    };
};

export default PrintConsulmoCombustivel;